import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../hooks/useReveal";

export default function ContactCTA() {
  const navigate = useNavigate();
  return (
    <section className="bg-[var(--cream)]" style={{ backgroundColor: "var(--cream)" }}>
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 py-24 md:py-36 text-center">
        <Reveal>
          <p className="font-script text-4xl md:text-5xl mb-6" style={{ color: "var(--sand)" }}>Let&rsquo;s build</p>
          <h2 className="font-serif-display text-[2.6rem] md:text-[4.6rem] leading-[1.02] font-300 text-[var(--navy)] max-w-4xl mx-auto" style={{ color: "var(--navy)" }}>
            Extraordinary spaces, together
          </h2>
          <p className="mt-8 text-[var(--muted)] text-base md:text-lg max-w-xl mx-auto" style={{ color: "var(--muted)" }}>
            Have a project in mind? We&rsquo;d love to hear about your space and how we can bring it to life.
          </p>
          <button
            onClick={() => { navigate("/contact"); window.scrollTo({ top: 0 }); }}
            className="btn-line btn-navy mt-10 group"
            style={{ color: "var(--navy)" }}
          >
            Start a project <ArrowRight size={16} strokeWidth={1.5} className="transition-transform duration-500 group-hover:translate-x-1" />
          </button>
        </Reveal>
      </div>
    </section>
  );
}
